import { render, staticRenderFns } from "./CarrierList.vue?vue&type=template&id=010609a2&scoped=true&"
import script from "./CarrierList.vue?vue&type=script&lang=js&"
export * from "./CarrierList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010609a2",
  null
  
)

export default component.exports